import React from 'react';
import { useRegion } from '../contexts/RegionContext';

export type GameStatus = 'in_progress' | 'released' | 'coming_soon';

interface StatusBadgeProps {
  status: GameStatus;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
  const { t, direction } = useRegion();

  const getStatusConfig = (st: GameStatus) => {
    switch (st) {
      case 'in_progress':
        return {
          text: t('games.statusInProgress'),
          bgColor: 'bg-amber-500 text-black',
        };
      case 'released':
        return {
          text: t('games.statusReleased'),
          bgColor: 'bg-emerald-500 text-black',
        };
      case 'coming_soon':
        return {
          text: t('games.statusComingSoon'),
          bgColor: 'bg-blue-500 text-white',
        };
      default:
        return {
          text: '',
          bgColor: '',
        };
    }
  };

  const { text, bgColor } = getStatusConfig(status);

  if (!text) return null;

  return (
    <span
      className={`absolute top-4 ${
        direction === 'rtl' ? 'left-4' : 'right-4'
      } ${bgColor} text-xs font-black px-2.5 py-1 rounded-full shadow-lg ${className}`}
    >
      {text}
    </span>
  );
};

export default StatusBadge;
